export const BREAKPOINT_SIDER = 'xl';
export const SIDE_NAV_WIDTH = 260;
